import { ContextService } from '../../../services/context_service';
import { DatenverwaltungEnergiesteuer } from './DatenverwaltungEnergiesteuer';
import { DatenverwaltungGtz } from './DatenverwaltungGtz';
import { DatenverwaltungGtzOrte } from './DatenverwaltungGtzOrte';
import { DatenverwaltungHeizwerte } from './DatenverwaltungHeizwerte';
import { DatenverwaltungQuellen } from './DatenverwaltungQuellen';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { Routing } from '../../../helpers/Routing';
import { RoutingIDs } from '../../../helpers/RoutingAdminIDs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';

interface DatenverwaltungTabEnergieProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortSelected: any;
}

interface DatenverwaltungTabEnergieState {
    tabIndex: number;
}

export class DatenverwaltungTabEnergie extends React.Component<DatenverwaltungTabEnergieProps, DatenverwaltungTabEnergieState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: null
        };
    }

    @lazyInject(ContextService) private contextService: ContextService;

    private disabled: string[] = [];
    private prefix: string = 'admin.tab.datenverwaltung.energie';
    private rechte: any = {};
    private tabName: string = RoutingIDs.TABS_DATENVERWALTUNG_ENERGIE;
    private tabIndex: string = `${this.tabName}Index`;
    private tabRoutings: any[] = [
        { path: RoutingIDs.ROUTE_ENERGIE_ENERGIESTEUER },
        { path: RoutingIDs.ROUTE_ENERGIE_HEIZWERTE },
        { path: RoutingIDs.ROUTE_ENERGIE_QUELLEN },
        { path: RoutingIDs.ROUTE_ENERGIE_GRADTAGSZAHLEN },
        { path: RoutingIDs.ROUTE_ENERGIE_GRADTAGSZAHLEN_ORTE }
    ];
    private tabs: string[] = [ // Reitereihenfolge beachten
        'energiesteuer', 'heizwerte', 'quellen', 'gradtagszahlen', 'gradtagszahlen_orte'
    ];

    componentDidMount(): void {
        (new Routing(this)).init((rechte: any, tabIndex: number) => {
            this.rechte = rechte || {};
            this.setTabIndex(tabIndex, this.tabRoutings[tabIndex]);
        });
    }

    componentDidUpdate(prevProps: any): void {
        if (JSON.stringify(this.props.routing) !== JSON.stringify(prevProps.routing)) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        if (typeof (routing.path || {})[this.tabName] === 'undefined') {
            return;
        }
        // this.setTabIndex(routing.path[this.tabName], routing, () => {
        //     if (routing.path.terminateOn === this.tabName) {
        //         this.props.onRoutingChange({});
        //     }
        // });
        if (this.state.tabIndex === routing.path[this.tabName]) {
            if (routing.path.terminateOn === this.tabName) {
                this.props.onRoutingChange({});
            }
        } else {
            this.setTabIndex(routing.path[this.tabName], routing);
        }
    }

    render(): JSX.Element {
        if (this.state.tabIndex === null) {
            return null;
        }

        return (
            <Tabs
                className='tabs-admin-datenverwaltung'
                selectedIndex={this.state.tabIndex}
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, this.tabRoutings[tabIndex])}
            >
                <TabList>
                    <Tab disabled={!this.rechte.energiesteuer}>Energiesteuer</Tab>
                    <Tab disabled={!this.rechte.heizwerte}>Heizwerte</Tab>
                    <Tab disabled={!this.rechte.quellen}>Quellen</Tab>
                    <Tab disabled={!this.rechte.gradtagszahlen}>Gradtagzahlen</Tab>
                    <Tab disabled={!this.rechte.gradtagszahlen_orte}>Gradtagzahlen Orte</Tab>
                </TabList>
                <TabPanel>
                    {this.rechte.energiesteuer &&
                        <DatenverwaltungEnergiesteuer />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.heizwerte &&
                        <DatenverwaltungHeizwerte />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.quellen &&
                        <DatenverwaltungQuellen />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.gradtagszahlen &&
                        <DatenverwaltungGtz data={this.props.data} />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.gradtagszahlen_orte &&
                        <DatenverwaltungGtzOrte data={this.props.data} />
                    }
                </TabPanel>
            </Tabs>
        );
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void): void {
        if (this.state.tabIndex !== tabIndex) {
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set(this.tabIndex, tabIndex);

                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            });
        }
    }
}
